import $ from "jquery";
// import Swiper JS
import Swiper, { Navigation, Pagination, Scrollbar } from 'swiper';
// import Swiper styles
import 'swiper/swiper-bundle.css';

// configure Swiper to use modules
Swiper.use([Navigation, Pagination, Scrollbar]);

$('.slider_c739').each(function(){

  var $slider = $(this);
  var $slides = $slider.find('.slider_c739__slides');
  var $prev = $slider.find('.slider_c739__prev');
  var $next = $slider.find('.slider_c739__next');

  var slides_perview_desktop = 3;
  console.log("slides_perview_desktop: " + slides_perview_desktop);

  if ($(this).data('slides_perview_desktop')){
    var slide_perview_data = $(this).data('slides_perview_desktop');
    if (slide_perview_data && slide_perview_data > 0){
      slides_perview_desktop = $(this).data('slides_perview_desktop');
      console.log("Contains data slides_perview_desktop: " + slides_perview_desktop);
    }

  }


  new Swiper($slides[0], {
    slidesPerView: 1,
    // If we need pagination
    // pagination: {
    //   el: '.swiper-pagination',
    //   clickable: true,
    // },
    // scrollbar: {
    //   el: '.swiper-scrollbar',
    //   hide: false,
    // },
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      1080: {
        slidesPerView: slides_perview_desktop,
      }
    },
    // Navigation arrows
    navigation: {
      nextEl: $next[0],
      prevEl: $prev[0],
    }
  });

});
